import { render } from "./PaymentReceiptsPageShell.vue?vue&type=template&id=0b43eba7&scoped=true"
import script from "./PaymentReceiptsPageShell.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptsPageShell.vue?vue&type=script&lang=js"

import "./PaymentReceiptsPageShell.vue?vue&type=style&index=0&id=0b43eba7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b43eba7"]])

export default __exports__